/**
 * @param {number|string} price
 * @param {'month'|'year'} basePeriod
 * @returns {number}
 */
export const yearlyPrice = (price, basePeriod) => {
    return parseInt(price, 10) * (basePeriod === 'month' ? 12 : 1);
};

/**
 * @param {number|string} price
 * @param {'month'|'year'} basePeriod
 * @returns {number}
 */
export const monthlyPrice = (price, basePeriod) => {
    return parseInt(price, 10) / (basePeriod === 'year' ? 12 : 1);
};

/**
 * Finds the price entry of an addon or product matching the given billing period.
 * @param {import('./ProductUtils').Addon} addon
 * @param {'month'|'year'} period
 * @returns {import('./ProductUtils').AddonPrice}
 * @throws {Error} when the addon has no price for the requested period
 */
export const getPriceForPeriod = (addon, period) => {
    const price = addon.prices.find((addonPrice) => addonPrice.billing_period === period);

    if (!price) {
        throw new Error(`No price found for period "${period}" on addon "${addon.name}"`);
    }

    return price;
};

const priceForPeriod = {
    monthlyPrice,
    yearlyPrice,
    getPriceForPeriod,
};

export default priceForPeriod;
